import React, { useState, setGlobal } from "reactn";
import clsx from "clsx";
import PropTypes from "prop-types";
import moment from "moment";
// import PerfectScrollbar from "react-perfect-scrollbar";
import { makeStyles } from "@material-ui/styles";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {
  Card,
  CardContent,
  Table,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  Button,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider
} from "@material-ui/core";
import CommentIcon from "@material-ui/icons/Comment";
import _ from "lodash";
import * as API from "../../../../api/api";
import Layout from "../../../Account/components/Layout/Layout";
import localization from "moment/locale/nl";
import ViewDayIcon from "@material-ui/icons/ViewDay";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
moment.updateLocale("nl", localization);

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050,
    [theme.breakpoints.down("sm")]: {
      minWidth: "auto" // ← voorkomt horizontale scroll op mobiel
    }
  },
  nameContainer: {
    display: "flex",
    alignItems: "center"
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: "flex-end"
  },
  // nieuw: cellen die ellipsis nodig hebben
  hashCell: {
    maxWidth: 200,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("sm")]: { maxWidth: 140 }
  },

  // nieuw: wrapper voor mobiele lijst met nette hoogte/scroll
  mobileWrap: {
    maxHeight: "70vh",
    overflow: "auto"
  },
  // IETS grotere “caption”-look (≈ body2) voor onderregels in mobile list
  biggerSecondary: {
    fontSize: "0.8rem", // iets groter dan caption (0.75rem) en ongeveer body2 (0.875rem)
    lineHeight: 1.3,
    color: theme.palette.text.secondary
  },
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content"
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 120
  },
  formControlLabel: {
    marginTop: theme.spacing(1)
  },
  iconCell: {
    width: 100,
    textAlign: "center"
  }

}));

const DevicesTable = props => {
  const { className, devices, ...rest } = props;

  const classes = useStyles();

  // Verwijderd: rowsPerPage, page, select-handlers, removeDevice (waren ongebruikt)
  const [layoutDeviceHash, setLayoutDeviceHash] = useState("");

  const [open, setOpen] = useState(false);
  const [layoutOpen, setLayoutOpen] = useState(false);
  const [currentDeviceHash, setCurrentDeviceHash] = useState("");
  const [currentComment, setCurrentComment] = useState("");
  const [emptyStatusModalOpen, setEmptyStatusModalOpen] = useState(false);
  const [deviceHashToClearStatus, setDeviceHashToClearStatus] = useState("");

  const handleClickOpen = (device_hash, comment) => {
    setCurrentDeviceHash(device_hash);
    setCurrentComment(comment);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentDeviceHash("");
    setCurrentComment("");
  };

  const handleKenmerkChange = _.debounce((device_hash, value) => {
    if (value != null) {
      API.doUpdateDevice({ device_hash, kenmerk: value });
    }
  }, 250);

  const saveCommentChange = _.debounce(value => {
    if (currentDeviceHash && value != null) {
      API.doUpdateDevice({
        device_hash: currentDeviceHash,
        commentaar: value
      });
    }
  }, 250);

  const handleLayoutClose = () => {
    setLayoutOpen(false);
    setLayoutDeviceHash("");
  };

  const handleLayoutOpen = device_hash => {
    setLayoutDeviceHash(device_hash);
    setLayoutOpen(true);
  };

  const showEmptyStatusModal = device_hash => {
    setEmptyStatusModalOpen(true);
    setDeviceHashToClearStatus(device_hash);
  };

  const emptyDeviceStatus = async () => {
    try {
      if (deviceHashToClearStatus) {
        await API.doEmptyStatus(deviceHashToClearStatus).then(r => {
          if (r.status === "OK") {
            setGlobal({
              hasError: true,
              errorMessage: "Status is nu leeg"
            });
          } else {
            setGlobal({
              hasError: true,
              errorMessage: "Kon status niet leegmaken.."
            });
          }
        });
      }
    } catch (err) {
      setGlobal({
        hasError: true,
        errorMessage: "Kon status niet leegmaken.."
      });
    } finally {
      setEmptyStatusModalOpen(false);
    }
  };
	// --- veilige parser voor lastUpdated ---
	const toMoment = (v) => {
	if (moment.isMoment(v)) return v;                           // al een moment? gebruik 'm
	// Probeer ISO eerst (strikt)
	let m = moment(v, moment.ISO_8601, true);
	if (m.isValid()) return m;
	// Probeer Engels: "Tuesday, August 26, 2025 9:28 AM"
	m = moment(v, "dddd, MMMM D, YYYY h:mm A", "en", true);
	if (m.isValid()) return m;
	// Laatste redmiddel: Date() (minder betrouwbaar)
	return moment(new Date(v));
	};


  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  const MobileDeviceList = ({ devices }) => (
    <List dense>
      {devices.map(device => (
        <React.Fragment key={`${device.device_hash}-${device.lastUpdated ?? 'na'}`}>
          <ListItem button onClick={() => handleLayoutOpen(device.device_hash)}>
            <ListItemText
              primary={device.kenmerk || device.device_hash}
              secondary={
                <>
                  <div className={classes.biggerSecondary}>
                    <span className={classes.hashCell}>{device.device_hash}</span>
                  </div>
                  <div className={classes.biggerSecondary}>
                    {toMoment(device.lastUpdated).locale('nl').fromNow()}
                  </div>
                </>
              }
            />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                aria-label="comment"
                onClick={() => handleClickOpen(device.device_hash, device.commentaar)}
              >
                <CommentIcon />
              </IconButton>
              <IconButton
                edge="end"
                aria-label="layout"
                onClick={() => handleLayoutOpen(device.device_hash)}
              >
                <ViewDayIcon />
              </IconButton>
              <IconButton
                edge="end"
                aria-label="clear-status"
                onClick={() => showEmptyStatusModal(device.device_hash)}
              >
                <HourglassEmptyIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider component="li" />
        </React.Fragment>
      ))}
    </List>
  );

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{"Commentaar"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <TextField
              id="outlined-multiline-static"
              multiline
              rows={25}
              defaultValue={currentComment}
              variant="outlined"
              onChange={event => {
                saveCommentChange(event.target.value);
              }}
              fullWidth
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Annuleren
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={emptyStatusModalOpen}
        onClose={() => {
          setEmptyStatusModalOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{"Weet je het zeker?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            U staat op het punt om alle statussen te verwijderen van{" "}
            <strong>{deviceHashToClearStatus}</strong>, weet je dit zeker?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setEmptyStatusModalOpen(false);
            }}
            color="secondary"
          >
            Annuleren
          </Button>
          <Button
            onClick={() => {
              emptyDeviceStatus();
            }}
            color="primary"
          >
            Leegmaken
          </Button>
        </DialogActions>
      </Dialog>

      <Card {...rest} className={clsx(classes.root, className)}>
        <CardContent className={classes.content}>
          {isXs ? (
            // MOBIEL: lijstweergave (geen horizontale scroll, grotere ‘caption’)
            <div className={classes.mobileWrap}>
              <MobileDeviceList devices={devices} />
            </div>
          ) : (
            // DESKTOP: gewone tabel, native scroll als nodig
            <div className={classes.inner} style={{ overflowX: "auto" }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Device Hash</TableCell>
                    <TableCell>Kenmerk</TableCell>
                    <TableCell>Laatste Actie</TableCell>
                    <TableCell>Notes</TableCell>
                    <TableCell>Layout</TableCell>
                    <TableCell>Status Reset</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {devices.map(device => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={`${device.device_hash}-${device.lastUpdated ?? 'na'}`}
                    >
                      <TableCell className={classes.hashCell}>
                        {device.device_hash}
                      </TableCell>
                      <TableCell>
                        <TextField
                          label="Kenmerk"
                          defaultValue={device.kenmerk}
                          onChange={event => {
                            handleKenmerkChange(
                              device.device_hash,
                              event.target.value
                            );
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        {toMoment(device.lastUpdated).locale('nl').fromNow()}
                        <br />
                        {toMoment(device.lastUpdated).locale('nl').format("D MMMM YYYY, H:mm:ss")}
                      </TableCell>
                      <TableCell className={classes.iconCell}>
                        <IconButton
                          aria-label="comment"
                          title="Bekijk of bewerk commentaar"
                          onClick={() =>
                            handleClickOpen(
                              device.device_hash,
                              device.commentaar
                            )
                          }
                        >
                          <CommentIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell className={classes.iconCell}>  
                        <IconButton
                          aria-label="layout"
                          title="Bekijk of bewerk layout"
                          onClick={() => handleLayoutOpen(device.device_hash)}
                        >
                          <ViewDayIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell>
                        <IconButton
                          aria-label="clear-status"
                          title="Reset status van dit apparaat"
                          onClick={() =>
                            showEmptyStatusModal(device.device_hash)
                          }
                        >
                          <HourglassEmptyIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>

      <Dialog
        open={layoutOpen}
        onClose={handleLayoutClose}
        fullWidth
        maxWidth="lg" // breed (S–L), maar niet schermvullend
        scroll="paper" // scroll binnen de popup, niet de pagina
        PaperProps={{
          // hoogte en evt. breedte van de popup
          style: { height: "90vh", width: "90vw", maxWidth: 1200 }
        }}
      >
        {/* Back-knop zit al in je Layout via CardHeader->avatar/action (zoals we deden) */}
        <Layout device_hash={layoutDeviceHash} onBack={handleLayoutClose} />
      </Dialog>
    </>
  );
};

DevicesTable.propTypes = {
  className: PropTypes.string,
  devices: PropTypes.array.isRequired
};

export default DevicesTable;
